module.exports = __webpack_public_path__ + "img/internet.cca13ee8.svg";